import { render } from "./LabelMarketingItem.vue?vue&type=template&id=161f1ab1&scoped=true"
import script from "./LabelMarketingItem.vue?vue&type=script&lang=js"
export * from "./LabelMarketingItem.vue?vue&type=script&lang=js"

import "./LabelMarketingItem.vue?vue&type=style&index=0&id=161f1ab1&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161f1ab1"]])

export default __exports__